import React, { useState } from 'react';
import CodeOptionsTable from './CodeOptionsTable';
import CodesTable from './CodesTable';
import { useDispatch } from 'react-redux';
import { fetchCodes } from '../../store/actions/codeActions';
import { PageHeader } from '../ForBrands/ui/BrandUI';
import '../ForBrands/brandMode.css';

// Admin Mode > Codes. The code options (sport, school, team and the rest)
// sit on the left and the codes of the selected option on the right; the two
// cards stack on a narrow screen. AdminModeLayout draws the frame, the tab
// bar and the gutter, so this page draws only its header and the two cards.

const CodeRelationPage = () => {
  const [selectedOption, setSelectedOption] = useState(null);
  const dispatch = useDispatch();

  const handleSelectOption = (option) => {
    setSelectedOption(option);

    if (option && Object.keys(option).length > 0) {
      dispatch(fetchCodes(option._id));  // Fetch codes by CodeOption _id
    }
  };

  return (
    <div className="bm-root w-full min-w-0 max-w-full">
      <PageHeader
        eyebrow="Admin Mode"
        title="Codes"
        subtitle="The lists behind the pickers across CACHE, such as sports, schools, teams and levels of play."
      />
      <div className="grid w-full min-w-0 grid-cols-1 items-start gap-4 lg:grid-cols-[minmax(0,5fr)_minmax(0,7fr)]">
        <CodeOptionsTable onSelectOption={handleSelectOption} selectedId={selectedOption?._id} />
        <CodesTable selectedOption={selectedOption} />
      </div>
    </div>
  );
};

export default CodeRelationPage;
